export default {
      id: "clock-blue-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "icons/sprites.svg?7d89e56a78e1fceb4cbfb5d35e05fdc6#clock-blue",
      toString: function () {
        return this.url;
      }
    }